import { render } from "./NewDrivers.vue?vue&type=template&id=3d8a07ac&ts=true"
import script from "./NewDrivers.vue?vue&type=script&lang=ts"
export * from "./NewDrivers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__